import { render, staticRenderFns } from "./chemMaterialPop.vue?vue&type=template&id=ba2961f6"
import script from "./chemMaterialPop.vue?vue&type=script&lang=js"
export * from "./chemMaterialPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba2961f6')) {
      api.createRecord('ba2961f6', component.options)
    } else {
      api.reload('ba2961f6', component.options)
    }
    module.hot.accept("./chemMaterialPop.vue?vue&type=template&id=ba2961f6", function () {
      api.rerender('ba2961f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/material/chemMaterialPop.vue"
export default component.exports